<template>
  <img class="pd-VendorSide_GoogleStaticMap" border="0" :src="googleMapsSrc" />
</template>

<script>
export default {
  name: "StoreStaticMapGoogle",
  props: {
    apikey: {
      required: true,
      type: String,
    },
    zoomlevel: {
      required: true,
      type: String,
    },
    lat: {
      required: true,
      type: String,
    },
    lng: {
      required: true,
      type: String,
    },
    mapstyle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      googleMapsBase: "https://maps.googleapis.com/maps/api/staticmap",
      mapType: "maptype=roadmap",
      size: null,
    };
  },
  computed: {
    center() {
      return `center=${this.lat},${this.lng}`;
    },
    zoom() {
      return `zoom=${this.zoomlevel}`;
    },
    marker() {
      return `markers=color:red|${this.lat},${this.lng}`;
    },
    key() {
      return `key=${this.apikey}`;
    },
    queryParameters() {
      return [
        this.center,
        this.zoom,
        this.size,
        this.mapType,
        this.mapstyle,
        this.marker,
        this.key,
      ].join("&");
    },
    googleMapsSrc() {
      return [this.googleMapsBase, this.queryParameters].join("?");
    },
  },
  mounted() {
    window.addEventListener("resize", this.setMapSize);
    this.setMapSize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setMapSize);
  },
  methods: {
    setMapSize /* istanbul ignore next */() {
      this.size = `size=${this.$el.parentElement.clientWidth}x${Math.round(
        this.$el.parentElement.clientWidth / 2
      )}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.pd-VendorSide_GoogleStaticMap {
  width: 100%;
  height: 100%;
}
</style>
